import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/pricing.svg',
})
export class PricingComponent {}
